var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumberOneBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589",
    transform: "translate(-10.5 46.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(11 -46)",
    fill: "none",
    stroke: "#0f688b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(15 -34)",
    fill: "rgba(225,30,36,0.77)",
    fontSize: 12,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberOneBlue);
export default __webpack_public_path__ + "static/media/NumberOneBlue.af9246ed6abdae567bee97fad55b99b7.svg";
export { ForwardRef as ReactComponent };